import { BFormRating } from './form-rating';
import { pluginFactory } from '../../utils/plugins';
var FormRatingPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BFormRating: BFormRating,
    BRating: BFormRating
  }
});
export { FormRatingPlugin, BFormRating };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/form-rating/index.js
// module id = 199
// module chunks = 0